/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

import useAuth from 'providers/Auth/useAuth';
import useCourse from 'providers/Course/useCourse';

import './structure.scss';

import Menu from 'components/generics/Menu/Menu';
import Header from 'components/generics/Header/Header';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { courses, loading } = useCourse();
  const history = useHistory();

  const [navState, setNavState] = useState(false);

  useEffect(() => {
    if (!user) {
      try {
        jwtDecode(localStorage.getItem('jwt_token'));
      } catch (error) {
        history.push('/login');
      }
    }
  }, [user]);

  const isAdmin = ['Admin', 'CPSAdmin'].includes(user?.roleName);
  // Un utilisateur sans course ne doit pas accéder aux données de l'application.
  const noCourse = !!user && !loading && !isAdmin && courses.length === 0;

  return (
    user && (
      <div className={`page${navState ? ' navExpand' : ''}`}>
        <Menu navState={navState} user={user} />
        <div>
          <Header connectionState={{ state: 'online' }} toggleMenu={() => setNavState(!navState)} navState={navState} />
          <div className="content">
            {noCourse ? (
              <div className="noCourse">
                <h1>Aucune course attribuée</h1>
                <p>Votre compte n'est associé à aucune course. Contactez un administrateur.</p>
              </div>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    )
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ProtectedRoute;
